import * as tslib_1 from "tslib";
import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import setMailboxJunkEmailConfiguration from '../services/setMailboxJunkEmailConfiguration';
export default action('saveMailboxJunkMailConfiguration')(function saveMailboxJunkMailConfiguration(mailboxJunkEmailConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store.mailboxJunkEmailConfiguration = mailboxJunkEmailConfiguration;
                    return [4 /*yield*/, setMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveMailboxJunkEmailConfiguration.js.map